<div class="pagelist">
    <button
            type="button"
            class="list-button nav-button"
            (click)="setPage('PREV')"
            [attr.disabled]="pageMeta.page === 0 || (!pageMeta.page && pageMeta.page !== 0) ? true : null"
    >
        <i class="fas fa-chevron-left"></i>
    </button>
    <button
            type="button"
            class="list-button"
            [class.current-page]="pageMeta.page === 0"
            [attr.disabled]="pageMeta.page === 0 ? true : null"
            (click)="setPage('FIRST')"
    >
        1
    </button>
    <span class="list-ellipsis" *ngIf="showEllipsis('left')">
            <i class="la la-ellipsis-h"></i>
        </span>
    <ng-container *ngFor="let pageNumber of pageRange">
        <button
                type="button"
                class="list-button"
                *ngIf="showPage(pageNumber)"
                [class.current-page]="pageMeta.page === pageNumber"
                [attr.disabled]="pageMeta.page === pageNumber ? true : null"
                (click)="setPage('PAGE', pageNumber)"
        >
            {{ pageNumber + 1 }}
        </button>
    </ng-container>
    <span class="list-ellipsis" *ngIf="showEllipsis('right')">
            <i class="la la-ellipsis-h"></i>
        </span>
    <button
            type="button"
            class="list-button"
            [class.current-page]="pageMeta.page === pageMeta.pages - 1"
            (click)="setPage('LAST')"
            *ngIf="pageMeta.pages > 1"
    >
        {{ pageMeta.pages }}
    </button>
    <button
            type="button"
            class="list-button nav-button"
            (click)="setPage('NEXT')"
            [disabled]="pageMeta.page === pageMeta.pages - 1 || pageMeta.pages === 0 || (!pageMeta.page && pageMeta.page !== 0)"
    >
        <i class="fas fa-chevron-right"></i>
    </button>
</div>

<ng-select
        class="per-page-selector"
        editableSearchTerm="false"
        appendTo="body"
        [clearable]="false"
        dropdownPosition="top"
        [closeOnSelect]="true"
        [searchable]="false"
        [(ngModel)]="pageMeta.perPage"
        (change)="setItemPerPage()"
>
    <ng-option *ngFor="let item of listPerPage" [value]="item">
        {{ item }} / pág
    </ng-option>
</ng-select>
